import { TitleCasePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { VfmService } from 'src/app/services/io/vfm.service';
import { IconsService } from 'src/app/services/ux/icons.service';
import { ThemeService } from 'src/app/services/ux/theme.service';
import { ExplorerManager } from '../../classes/explorer-manager';
import { IPathPart } from '../../interfaces/path-path';

@Component({
  selector: 'app-explorer-main-menu',
  templateUrl: './explorer-main-menu.component.html',
  styleUrls: ['./explorer-main-menu.component.scss']
})
export class ExplorerMainMenuComponent implements OnInit, OnDestroy {
  @Input() explorerManager: ExplorerManager;

  private subscription: Subscription;

  pathParts: IPathPart[] = [];

  constructor(
    public theme: ThemeService,
    private iconSv: IconsService
  ) {
  }

  ngOnInit(): void {
    this.reloadPath();
    this.subscription = this.explorerManager.changeEvent.subscribe(() => {
      this.reloadPath();
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  get iconFolder() {
    return this.iconSv.getIcon("folder");
  }

  navigate(path: string) {
    this.explorerManager.cwd = path;
  }

  private reloadPath() {
    const parts = this.explorerManager.cwd ? this.explorerManager.cwd.split("/") : [];

    this.pathParts = [];

    for (let i = 0; i < parts.length; i++) {
      const p: IPathPart = {
        name: new TitleCasePipe().transform(parts[i]),
        path: parts.slice(0, i + 1).join("/")
      };

      this.pathParts.push(p);
    }

    if (this.pathParts.length === 0) {
      this.pathParts.push({ name: "This computer", path: "" });
    }
  }
}
